// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"241":"81420927","329":"67c534c5","501":"a8ed859a","512":"553e410f","707":"10cdf007"}[chunkId] + ".js";
};